<script>
import options from './CreateStafetProfile.options'
  export default options
</script>

<template>
  <article
    class="kb-stafet-profile-form kb-stafet-donation-flow__step kb-optimizely-forms"
  >
    <div class="kb-stafet-step">
      <h2 class="kb-stafet-step__title">
        {{ labels.title }}
      </h2>

      <div class="kb-stafet-step__input-wrapper">
        <div
          class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
        >
          <FormInputTextField
            :modelValue="firstNameInput"
            v-model="firstNameInput"
            fieldName="firstName"
            :readOnly="isReadOnly.firstName"
            :label="labels.firstNameLabel"
            :isRequired="true"
            :isValidationError="showFirstNameErrorMessage"
            :errorMessageLabel="labels.firstNameErrorMessage"
          />
            
          <FormInputTextField
            :modelValue="lastNameInput"
            v-model="lastNameInput"
            fieldName="lastName"
            :readOnly="isReadOnly.lastName"
            :label="labels.lastNameLabel"
            :isRequired="true"
            :isValidationError="showFirstNameErrorMessage"
            :errorMessageLabel="labels.lastNameErrorMessage"
          />
        </div>

        <div
          class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
        >
          <FormInputTextField
            :modelValue="phoneInput"
            v-model="phoneInput"
            fieldName="phone"
            :readOnly="isReadOnly.phone"
            :label="labels.phoneNumberLabel"
            :isValidationError="showPhoneErrorMessage"
            :errorMessageLabel="labels.phoneNumberErrorMessage"
          />
            
          <FormInputTextField
            :modelValue="email"
            fieldName="email"
            :readOnly="true"
            :label="labels.emailLabel"
            :errorMessageLabel="labels.emailErrorMessage"
            isRequired
          />
        </div>
      </div>

      <div class="kb-rich-text">
        <div class="kb-rich-text__content" ref="informationRichTextWrapper">
        </div>
      </div>
      
      <div class="kb-stafet-flow-actions__buttons-wrapper">
        <button class="kb-button kb-button--full-color-spot" :class="{'kb-button--disabled': isSubmitting}" :onClick="submitCreateProfile">
          {{ labels.createProfileCtaLabel}}
        </button>
      </div>

      <template v-if="isSubmitting">
        <div class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
        </div>
      </template>
      
    </div>
  </article>
</template>
